// The leading # is optional on input — normalize for the picker and the emit.
export const normalizeHex = (color: string | null): string =>
  (color ?? '').replace('#', '').toUpperCase();
